<div class="ui-modal add-person-to-groups-dialog">
    <div class="header flex-row space-between-center">
        <div>{{ 'VEHICLE_GROUPS.ADD_VEHICLE_TO_GROUPS_DIALOG.TITLE' | translate }}</div>
        <span class="ui-icon-close c-p" tabindex="0" role="button" (click)="close()" (keydown.enter)="close()"></span>
    </div>

    <div class="body">
        @if (isVehicleGroupsLoading()) {
            <ui-preloader [color]="preloaderColor.blue"></ui-preloader>
        } @else {
            <div class="groups-selector">
                <div class="search-wrapper">
                    <ui-search
                            class="w-100"
                            [formControl]="searchControl"
                            [placeholder]="'VEHICLE_GROUPS.ADD_VEHICLE_TO_GROUPS_DIALOG.SEARCH_PLACEHOLDER' | translate"
                    ></ui-search>
                </div>
                <div class="groups-list">
                    @for (group of filteredGroups(); track group._id) {
                        <div
                                class="group-row flex-row start-center gap-8"
                                tabindex="0"
                                role="button"
                                (click)="toggleGroup(group._id)"
                                (keydown.enter)="toggleGroup(group._id)"
                                (keydown.space)="$event.preventDefault(); toggleGroup(group._id)"
                        >
                            <mat-checkbox
                                    [checked]="isGroupSelected(group._id)"
                                    (click)="$event.stopPropagation()"
                                    (change)="setGroupSelected(group._id, $event.checked)"
                            ></mat-checkbox>
                            <span class="group-name">{{ group.name }}</span>
                            <span class="group-count">
                {{ 'VEHICLE_GROUPS.ADD_VEHICLE_TO_GROUPS_DIALOG.VEHICLE_COUNT' | translate: { count: group.vehiclesCounter } }}
              </span>
                        </div>
                    }
                </div>
            </div>
            <ui-button
                    class="add-group-button"
                    type="secondary"
                    iconClass="ui-icon-plus"
                    [text]="'VEHICLE_GROUPS.ADD_VEHICLE_TO_GROUPS_DIALOG.ADD_NEW_GROUP' | translate"
                    (clickAction)="openCreateGroupDialog()"
            ></ui-button>
        }

    </div>

    <div class="footer flex-row end-center">
        <ui-button
                type="primary"
                [disabled]="saveDisabled()"
                [loading]="isAddingVehiclesToGroups()"
                [text]="'COMMON.SAVE' | translate"
                (clickAction)="save()"
        ></ui-button>
    </div>
</div>
